<!-- The module context is to turn this file into a library or singleton -->
<script context="module">
    import lib from "./lib/util.js";
    import { getToken, userInfo } from "./Me.svelte";
    import { client, gql } from "./GraphQL.svelte";

    const LOGIN_QUERY = gql`
        query($credentials: CredentialsInput){
          login(credentials: $credentials){
            token
          }
        }
    `;

    const REGISTER_MUTATION = gql`
        mutation($user: RegisterUserInput!) {
            registerUser(user: $user) {
                user {
                    firstName, id, lastName
                },
                token
            }
        }
    `;

    // use .then() to set token to local storage
    export function login({username, password}) {
        return client.query({
            fetchPolicy: "network-only",
            query: LOGIN_QUERY,
            variables: {credentials: {username: username, password: password}}
        }).then((response) => {
            let token = response.data.login.token;
            localStorage.setItem('token', token);
            console.log(`logged in, received token ${token}`);
        });
    }

    export function setToken(token) {
        localStorage.setItem('token', token);
    }

    export function register(data) {
        return client.mutate({
            mutation: REGISTER_MUTATION,
            variables: { user: data }
        });
    }

    //export const onLogin = getToken;
    export const onLogin = userInfo;

    // clear session
    export function clear() {
        localStorage.setItem('token', null);
        //client.reset();
    };

    export function logout() {
        clear();
        // TODO: do server logout
        // TODO: use reroute in App
        window.location.reload();
        return false;
    }
</script>